import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-297c161c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto mt-5 py-5" }
const _hoisted_2 = { class: "range" }
const _hoisted_3 = { class: "content d-flex justify-content-between px-3" }
const _hoisted_4 = { class: "naming" }
const _hoisted_5 = { class: "heading-3 mb-4" }
const _hoisted_6 = { class: "subhead-2" }
const _hoisted_7 = { class: "d-flex align-items-center gap-4" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "range__value",
        style: _normalizeStyle({ width: _ctx.index + '%' })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.author), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, { to: _ctx.prev }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "navigation-icon",
              src: _ctx.backBtn,
              alt: ""
            }, null, 8, _hoisted_8)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, { to: _ctx.next }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "navigation-icon",
              src: _ctx.nextBtn,
              alt: ""
            }, null, 8, _hoisted_9)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}